import React, { useEffect, useState } from 'react'

import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'

import {  showEmployes, updateEmployes } from '../../../../MyApi/sb/employes'

import PageHeader from '../../../../Components/UI/PageHeader'


import EditEmploy from '../../../../Components/sb/employ/employUpdate/EditEmploy'

     

const EmployesUpdate = () => {

 const {id} = useParams()
 const selectedLang = localStorage.getItem("i18nextLng")
const [selectedCodeLang , setSelectedCodeLang] =useState(selectedLang)
 const showEmployQuery = useQuery(["showEmployes",id,selectedCodeLang ],()=> showEmployes(id ,selectedCodeLang))
 const  employes = showEmployQuery.data?.data || {}
const [name_ar ,setNameAr]= useState("")
const [name_en ,setNameEn]= useState("")
const [mobile, setMobile] =useState("")
const [nation_id,setNationId]=useState("")
const [email,setEmail ] =useState("")
const [sb_country_id, setSbCountryId] =useState("")
const [sb_city_id, setSbCityId] = useState("")
const [sb_branch_id, setSbBranchId]=useState("")
const [sb_department_id ,setSbDepartmentId] =useState("")
const [sb_nationality_id ,setSbNationalityId] =useState("")
const [sb_company_id , setSbCompanyId]= useState("")
const [sb_shift_id ,setSbShiftId]=useState("")
const [address,setAdress]=useState("")
const [birthdate, setBirthDate]=useState("")
const [active,setActive]=useState("")
const [access_system, setAcessSystem]=useState("")
const [role, setRole]=useState("")
const [insurance_number, setInsuranceNumber]=useState("")
const [tax_number ,setTaxNumber]=useState("")
const [bank_name,setBankName]=useState("")
const [bank_swiftcode, setBankSwiftCode]=useState("")
const [bank_account_number, setBankAccountNumber]=useState("")
const [payroll_method, setPayrollMethod]=useState("")
const [image ,setImage]=useState("")
const [check_In_outside, setCheckInOutside]=useState(false)
useEffect(()=>{
    showEmployQuery.refetch()
},[selectedCodeLang])

useEffect(()=>{
    setNameAr(employes.name_ar)
    setNameEn(employes.name_en)
    setMobile(employes.mobile)
    setNationId(employes.nation_id)
    setEmail(employes.email)
    setSbCountryId(employes.country_id)
    setSbCityId(employes.city_id)
    setSbBranchId(employes.branch_id)
    setSbDepartmentId(employes.department_id)
    setSbNationalityId(employes.nationality_id)
    setSbCompanyId(employes.company_id)
    setAdress(employes.address)
    setBirthDate(employes.birthdate)
    setActive(employes.active)
    setAcessSystem(employes.access_system)
    setRole(employes.role)
    setInsuranceNumber(employes.insurance_number)
    setTaxNumber(employes.tax_number||"")
    setBankName(employes.bank_name||"")
    setBankSwiftCode(employes.bank_swiftcode||"")
    setBankAccountNumber(employes.bank_account_number||"")
    setPayrollMethod(employes.payroll_method)
    setCheckInOutside(employes.fixable_check)

},[ showEmployQuery.data])


 const mutation = useMutation(["updateEmployes",id ], (postData)=>updateEmployes(postData ,id) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)

    },     
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    } 
 })

 const handlePostRequest =()=>{
    const formData = new FormData()
    formData.append("name_ar", name_ar)
    formData.append("name_en", name_en)
    formData.append("mobile",mobile)
    formData.append("nation_id",nation_id)
    formData.append("email",email)
     formData.append("fixable_check",check_In_outside)
    formData.append("sb_country_id",sb_country_id)
    formData.append("sb_city_id", sb_city_id)
    formData.append("sb_branch_id", sb_branch_id)
    formData.append("sb_department_id",sb_department_id)
    formData.append("sb_nationality_id" , sb_nationality_id)
    formData.append("sb_company_id",sb_company_id)
    formData.append("address" , address)
    formData.append("birthdate",birthdate)
    formData.append("active",active)
    formData.append("access_system",access_system)
    formData.append("sb_shift_id",sb_shift_id)
    formData.append("image",image)
    formData.append("role" , role)
    formData.append("tax_number",tax_number)
    formData.append("insurance_number",insurance_number)
    formData.append("payroll_method",payroll_method)
    formData.append("bank_account_number",bank_account_number)
    formData.append("bank_swiftcode",bank_swiftcode)
    formData.append("bank_name",bank_name)
    formData.append("lang_code",selectedCodeLang)
    mutation.mutate(formData)
 }
 const isDisabled= ()=>{
    return 
    
 }
 const onSelectChange = (e)=>{
    setSelectedCodeLang(e.target.value)
 }
  return ( 
                  
    <div>
        <PageHeader title="Edit Employ" showSelect onSelectChange={onSelectChange}  showBack={true}  saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <EditEmploy  check_In_outside={check_In_outside} setCheckInOutside={setCheckInOutside}  image={image} payroll_method={payroll_method} setShiftId={setSbShiftId}  setImage={setImage} tax_number={tax_number} insurance_number={insurance_number}   bank_account_number={bank_account_number} bank_swiftcode={bank_swiftcode}  bank_name={bank_name} setInsuranceNumber={setInsuranceNumber} setTaxNumber={setTaxNumber} setBankName={setBankName} setBankSwiftCode={setBankSwiftCode} setBankAccountNumber={setBankAccountNumber} setPayrollMethod={setPayrollMethod}     sb_department_id={sb_department_id} sb_nationality_id={sb_nationality_id}  sb_country_id={sb_country_id}  sb_branch_id={sb_branch_id} role={role} sb_city_id={sb_city_id}      nation_id={nation_id} sb_company_id={sb_company_id}  name_ar={name_ar} name_en={name_en} active={active}  address={address}  access_system={access_system} email={email}  mobile={mobile} setActive={setActive}  birthdate={birthdate} setCityId={setSbCityId} setCountryId={setSbCountryId} setCompanyId={setSbCompanyId}  setNameAr={setNameAr} setNameEn={setNameEn} setMobile={setMobile} setNationId={setNationId} setBranchId={setSbBranchId} setEmail={setEmail} setAdress={setAdress} setSbDepartmentId={setSbDepartmentId} setSbNationalityId={setSbNationalityId} setBirthDate={setBirthDate} setAcessSystem={setAcessSystem} setRole={setRole}/>
    </div>
  )
}

export default EmployesUpdate